export default "__VITE_ASSET__C58nzaoy__"